import { Component, OnInit, Input } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Entry } from 'contentful';

import { environment } from '../../../environments/environment';
import { GlobalContentService } from '../../services/global-content/global-content.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'app-share-link',
  templateUrl: './share-link.component.html',
  styleUrls: ['./share-link.component.scss']
})
export class ShareLinkComponent implements OnInit {
  @Input() public linkToShare: string;
  @Input() public mailBody: Array<any>;
  @Input() public title: string;
  @Input() public analyticsCategory: string;
  @Input() public iconBackgroundColor: string;
  public globalContent$: Observable<Entry<any>>;

  public sharingNotification$: Observable<string>;
  public showSharingNotification = false;

  constructor(
    private clipboardService: ClipboardService,
    private analyticsService: AnalyticsService,
    private globalContentService: GlobalContentService
  ) {}

  ngOnInit() {
    this.globalContent$ = this.globalContentService.getGlobalContent();
    this.sharingNotification$ = this.globalContent$.pipe(
      map((globalContent: Entry<any>) => {
        return globalContent.fields.linkCopied;
      })
    );
  }

  get source() {
    return environment.host.replace('https://', '').replace('http://', '');
  }

  get twitterShareLink() {
    return (
      'https://twitter.com/intent/tweet?text=' +
      this.twitterText +
      '&url=' +
      encodeURIComponent(this.linkToShare)
    );
  }

  get facebookShareLink() {
    return (
      'http://www.facebook.com/share.php?u=' +
      encodeURIComponent(this.linkToShare)
    );
  }

  get twitterText() {
    return encodeURIComponent(this.title + ' #WeCompensate');
  }

  get linkedinShareLink() {
    return (
      'http://www.linkedin.com/shareArticle?mini=true&url=' +
      encodeURIComponent(this.linkToShare) +
      '&title=' +
      this.title +
      '&source=' +
      this.source
    );
  }

  get mailShareLink() {
    if (this.mailBody) {
      let body = this.mailBody
        .map((value: any) => value.content[0].value)
        .join('%0D%0A%0D%0A');
      body += '%0D%0A%0D%0A' + encodeURIComponent(this.linkToShare);
      const subject = this.title;
      return 'mailto:?body=' + body + '&subject=' + subject;
    }

    return `mailto:?body=${this.linkToShare}&subject=${this.title}`;
  }

  click(channel) {
    this.analyticsService.clickShareButton(this.analyticsCategory, channel);
  }

  copyLink() {
    this.clipboardService.copyFromContent(this.linkToShare);
    this.analyticsService.clickShareButton(
      this.analyticsCategory,
      'link copied'
    );
    this.showSharingNotification = true;
  }
}
